import { LoadingLine } from "../../../components/loading-line.js";
import { UserPrivateServiceModel } from "./model.js";
import { UserPrivateServiceView } from "./view.js";
import { ITEM_OPTIONS } from "../../../config/constants.js";
import { ModalController } from "../../../components/modal/controller.js";
import { CheckInputValue } from "../../../config/functions.js";
import { LoadingDot } from "../../../components/loading-dot.js";
import { Doms } from "../../../components/doms.js";

export class UserPrivateServiceController {
  constructor() {
    this.model = new UserPrivateServiceModel();
    this.view = new UserPrivateServiceView();
    this.loading = LoadingLine.getInstance();
    this.doms = new Doms();

    this.modal = null;
    this.openning = false;
  }

  loadMain() {
    app.userPrivateController.viewGenericItems.loadMain(this, 'Mis servicios', 'servicios');
    history.pushState({}, '', `/user/servicios`);
    document.getElementById('btn-servicios').classList.add('active');
    document.getElementById('btn-header-servicios').classList.add('active');
  }

  new() {
    history.pushState({}, '', `/user/servicios/new`);
    this.modal = new ModalController("Publicar nuevo servicio", LoadingDot.render() + '<br><br>', 'form-servicios', app.userPrivateController.view.renderPublishButton('1'));
    app.userPrivateController.auth.sessionAlive()
      .then(() => {
        this.modal.doms.content.innerHTML = this.view.renderForm();
        APICRUD.Common.Select.SetData('servicios-categoria', 0, ITEM_OPTIONS.Categorias.Servicios);
        APICRUD.Common.Select.SetData('servicios-radio-de-accion', 0, ITEM_OPTIONS.RadiosDeAccion);
        APICRUD.Common.Select.SetData('servicios-moneda', 0, ITEM_OPTIONS.Monedas);
        APICRUD.Location.Selector_LoadStates('servicios-provincia', '5', '0');
        APICRUD.Location.Selector_LoadCities('servicios-localidad', '0', '0');
      })
      .catch(_error => {
        console.log(_error);
        this.modal.doms.modal.innerHTML = '';
        this.modal.close();
        app.userPrivateController.auth.showLogin()
      })
  }

  create() {
    if (this.modal?.modal?.classList.contains('active')) {
      this.modal.doms.content.innerHTML = this.view.renderForm();
      this.view.gallery.checkButtons();
    } else {
      this.modal = new ModalController("Publicar nuevo servicio", this.view.renderForm(), 'form-servicios', app.userPrivateController.view.renderPublishButton('1'));
      this.modal.show();
      this.view.gallery.checkButtons();
    }
    APICRUD.Common.Select.SetData('servicios-categoria', 0, ITEM_OPTIONS.Categorias.Servicios);
    APICRUD.Common.Select.SetData('servicios-moneda', 0, ITEM_OPTIONS.Monedas);
    APICRUD.Common.Select.SetData('servicios-radio-de-accion', 0, ITEM_OPTIONS.RadiosDeAccion);
    APICRUD.Location.Selector_LoadStates('servicios-provincia', '5', '0');
    APICRUD.Location.Selector_LoadCities('servicios-localidad', '0', '0');
  }

  edit(_idcod) {
    if (this.openning === true) return;
    this.openning = true;
    this.modal = new ModalController("Editar servicio", LoadingDot.render() + '<br><br>', 'form-servicios', '<br>');
    this.modal.show();
    this.loading.show();
    this.model.read(_idcod)
      .then((servicio) => {
        this.modal.doms.content.innerHTML = this.view.renderForm(servicio.data);
        this.modal.doms.titleStatus.innerHTML = app.userPrivateController.view.renderPublishButton(servicio.data.visible);
        this.view.gallery.checkButtons();
        APICRUD.Common.Select.SetData('servicios-categoria', servicio.data.categoria, ITEM_OPTIONS.Categorias.Servicios);
        APICRUD.Common.Select.SetData('servicios-radio-de-accion', servicio.data['radio-de-accion'], ITEM_OPTIONS.RadiosDeAccion);
        APICRUD.Common.Select.SetData('servicios-moneda', servicio.data.moneda, ITEM_OPTIONS.Monedas);
        APICRUD.Location.Selector_LoadStates('servicios-provincia', '5', servicio.data.provincia);
        APICRUD.Location.Selector_LoadCities('servicios-localidad', servicio.data.provincia, servicio.data.localidad);
      })
      .catch(error => {
        console.log(error);
        this.modal.close();
        let modal = new ModalController('Editar servicio', 'No existe el servicio.');
        modal.show();
        setTimeout(modal.close.bind(this), 5000);
      })
      .finally(() => {
        this.openning = false;
        this.loading.hide();
      });
  }

  delete(_title, _idcod) {
    this.modalDelete = new ModalController('Eliminar servicio');
    this.modalDelete.doms.content.innerHTML = this.view.renderDeleteConfirmation(_title, _idcod);
  }

  deleteConfirmation(_idcod) {
    this.model.delete(_idcod)
      .then(() => {
        this.modal?.close();
        this.modalDelete?.close();
        app.userPrivateController.router('servicios');
      })
      .catch(_error => {
        this.modalDelete.doms.content.innerHTML = _error;
        console.error(_error);
      });
  }

  deleteCancel() {
    this.modalDelete?.close();
  }

  async save() {
    // DONE: convertir a asyc/await
    // DONE: hacer funcion en auth que calcule si puede publicar en base a la cantidad.  Esta en usserPrivateController > canPublish

    let modalSave = new ModalController('Guardando', 'Enviando datos, por favor espere...');
    try {
      let idcod = this.doms.getValue('servicios-idcod');
      let newData = {
        titulo: this.doms.getValue('servicios-titulo'),
        categoria: this.doms.getValue('servicios-categoria'),
        resumen: this.doms.getValue('servicios-resumen'),
        descripcion: this.doms.getValue('servicios-descripcion'),
        precio: this.doms.getValue('servicios-precio'),
        moneda: this.doms.getValue('servicios-moneda') || '0',
        'radio-de-accion': this.doms.getValue('servicios-radio-de-accion'),
        localidad: this.doms.getValue('servicios-localidad') || '0',
        provincia: this.doms.getValue('servicios-provincia') || '0',
        maquinas: this.doms.getValue('servicios-maquinas'),
        software: this.doms.getValue('servicios-software'),
        imagenes: this.view.gallery.images,
        visible: this.doms.getDom('visible').checked === true ? '1' : '0'
      }

      if (idcod) {
        newData.idcod = idcod;
      }

      this.doms.setHTML('servicios-categoria-error', '');
      this.doms.setHTML('servicios-titulo-error', '');
      this.doms.setHTML('servicios-resumen-error', '');
      this.doms.setHTML('servicios-descripcion-error', '');
      this.doms.setHTML('servicios-precio-error', '');
      this.doms.setHTML('servicios-moneda-error', '');
      this.doms.setHTML('servicios-radio-de-accion-error', '');
      this.doms.setHTML('servicios-status', '');

      if (!newData.categoria || newData.categoria === '0') {
        this.doms.setHTML('servicios-categoria-error', 'Debe seleccionar una categoría.');
        this.doms.focus('servicios-categoria');
        return;
      } else if (!newData.titulo) {
        this.doms.setHTML('servicios-titulo-error', 'El título no puede estar vacío.');
        this.doms.focus('servicios-titulo');
        return;
      } else if (newData.titulo.length < 5) {
        this.doms.setHTML('servicios-titulo-error', 'El título debe tener al menos 5 caracteres.');
        this.doms.focus('servicios-titulo');
        return;
      } else if (!newData.resumen) {
        this.doms.setHTML('servicios-resumen-error', 'La descripción corta no puede estar vacía.');
        this.doms.focus('servicios-resumen');
        return;
      } else if (newData.resumen.length < 20) {
        this.doms.setHTML('servicios-resumen-error', 'La descripción debe tener al menos 20 caracteres.');
        this.doms.focus('servicios-resumen');
        return;
      } else if (this.doms.getDom('servicios-precio-radio-1').checked == true) {
        if (newData.precio.trim() == '' || newData.precio.trim() == '0') {
          this.doms.setHTML('servicios-precio-error', 'El precio no puede estar vacío.');
          this.doms.focus('servicios-precio');
          return;
        } else if (!CheckInputValue('servicios-precio')) {
          this.doms.setHTML('servicios-precio-error', 'El precio no puede ser menor a cero.');
          this.doms.focus('servicios-precio');
          return;
        } else if (newData.moneda === '0') {
          this.doms.setHTML('servicios-moneda-error', 'Debe seleccionar una moneda.');
          this.doms.focus('servicios-moneda');
          return;
        }
      }


      this.doms.setHTML('servicios-status', 'Guardando...');

      let func = 'Create';
      let text = 'Creando nuevo servicio';
      if (newData.idcod) {
        func = 'Update';
        text = 'Guardando servicio';
      }

      if (await app.userPrivateController.account.canPublish(this.doms.getDom('visible').checked, newData.idcod) === false) {
        document.getElementById('visible').checked = false;
        newData.visible = '0';
      }

      modalSave.show();

      this.loading.show(text);
      await this.model.save(newData, func);
      this.doms.setHTML('servicios-status', 'Datos guardados.');
      app.userPrivateController.router('servicios');
      app.userPrivateController.servicios.modal.close();
      modalSave.doms.content.innerHTML = 'Datos guardados.';
      return 'OK';
    } catch (_error) {
      this.doms.setHTML('servicios-status', _error);
      modalSave.doms.content.innerHTML = _error;
      throw _error;
    } finally {
      this.loading.hide();
      modalSave.close();
    }
  }

}
